import React from 'react';
import { Box, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import MyContainer from "../MyContainer";
import { useI18n } from "../../i8n/useI18n";

const TermsPage = () => {
    const { t } = useI18n();

    return (
        <MyContainer>
            <Helmet>
                <title>{t("termsText.title")} | {t("brand.name")}</title>
            </Helmet>
            <Box sx={{ maxWidth: 720, py: 4 }}>
                <Typography variant="h2" sx={{ mb: 4 }}>{t("termsText.title")}</Typography>

                <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>{t("termsText.scopeTitle")}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 4, lineHeight: 1.8 }}>
                    {t("termsText.scopeText")}
                </Typography>

                <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>{t("termsText.contractTitle")}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 4, lineHeight: 1.8 }}>
                    {t("termsText.contractText")}
                </Typography>

                <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>{t("termsText.pricesTitle")}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 4, lineHeight: 1.8 }}>
                    {t("termsText.pricesText")}
                </Typography>

                <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>{t("termsText.withdrawalTitle")}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 4, lineHeight: 1.8 }}>
                    {t("termsText.withdrawalText")}
                </Typography>

                <Typography variant="caption" color="text.disabled" sx={{ display: "block", mt: 4 }}>
                    {t("termsText.disclaimerText")}
                </Typography>
            </Box>
        </MyContainer>
    );
};

export default TermsPage;
